/**
 * 공통 패널 스타일
 */

export const panelStyle = {
  padding: '16px',
  height: '100%',
  overflowY: 'auto',
};

export const titleStyle = {
  fontSize: '16px',
  fontWeight: '600',
  color: '#1f2937',
  marginBottom: '20px',
  paddingBottom: '12px',
  borderBottom: '1px solid #e5e7eb',
  margin: 0,
};

export const sectionStyle = {
  marginBottom: '20px',
};

export const labelStyle = {
  display: 'block',
  fontSize: '13px',
  fontWeight: '500',
  color: '#374151',
  marginBottom: '8px',
};

export const inputStyle = {
  flex: 1,
  padding: '8px 12px',
  border: '1px solid #e5e7eb',
  borderRadius: '6px',
  fontSize: '13px',
};

export const selectStyle = {
  width: '100%',
  padding: '10px 12px',
  border: '1px solid #e5e7eb',
  borderRadius: '6px',
  fontSize: '13px',
  backgroundColor: '#ffffff',
};

export const colorInputStyle = {
  width: '40px',
  height: '32px',
  border: 'none',
  cursor: 'pointer',
};

export const styleButtonStyle = {
  width: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
  borderRadius: '6px',
  cursor: 'pointer',
};

export const actionButtonStyle = (enabled = true) => ({
  flex: 1,
  padding: '10px 8px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '4px',
  border: '1px solid #e5e7eb',
  borderRadius: '8px',
  backgroundColor: '#ffffff',
  cursor: enabled ? 'pointer' : 'not-allowed',
  fontSize: '12px',
  color: enabled ? '#374151' : '#d1d5db',
  opacity: enabled ? 1 : 0.5,
});

export const shortcutRowStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '6px 0',
  borderBottom: '1px solid #f3f4f6',
};

export const kbdStyle = {
  padding: '2px 6px',
  backgroundColor: '#f3f4f6',
  borderRadius: '4px',
  fontSize: '11px',
  fontFamily: 'monospace',
};

export const loadingStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px',
  marginBottom: '20px',
  backgroundColor: '#f3f4f6',
  borderRadius: '12px',
  color: '#374151',
};
